<template>
  <div class="home-view">
    <!-- Hero -->
    <div class="hero" :style="heroStyle">
      <div class="hero-content">
        <h1>{{ config.content.heroTitle }}</h1>
        <router-link to="/transfer" class="ube-l-btn mx-3">
          {{ config.content.heroCTAText }}
        </router-link>
        <router-link
          v-if="twoToFourYearEnabled"
          to="/TwoYeartoFourYear"
          class="ube-l-btn-secondary mx-3"
        >
          2 Year to 4 Year Plan
        </router-link>
      </div>
    </div>

    <!-- How It Works -->
    <div class="how-it-works">
      <div class="section-heading">
        <h2>How it works</h2>
        <div class="heading-accent"></div>
      </div>

      <div class="steps-grid">
        <div class="step-col">
          <div class="step-top">
            <span class="step-number">01</span>
          </div>
          <div class="step-icon-wrap">
            <img class="icon" src="../assets/university.png" alt="university" />
          </div>
          <p class="step-text">Select your community college</p>
        </div>

        <div class="step-col">
          <div class="step-top">
            <span class="step-number">02</span>
          </div>
          <div class="step-icon-wrap">
            <img class="icon" src="../assets/graduation.png" alt="graduation" />
          </div>
          <p class="step-text">
            Select courses completed or in progress at your community college
          </p>
        </div>

        <div class="step-col step-col--last">
          <div class="step-top">
            <span class="step-number">03</span>
          </div>
          <div class="step-icon-wrap">
            <img class="icon" src="../assets/program.png" alt="program" />
          </div>
          <p class="step-text">
            Select the intended program/major at {{ config.branding.name }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { useTenantConfig } from "@/composables/useTenantConfig";
import { useFeatureFlags } from "@/composables/useFeatureFlags";

export default defineComponent({
  name: "HomeView",
  setup() {
    const { config } = useTenantConfig();
    const { twoToFourYearEnabled } = useFeatureFlags();

    // Compute hero background image URL
    const heroImageUrl = computed(() => {
      return new URL(`../assets/${config.branding.heroImage}`, import.meta.url).href;
    });

    // Compute hero style with background image
    const heroStyle = computed(() => ({
      backgroundImage: `url(${heroImageUrl.value})`,
    }));

    return {
      config,
      twoToFourYearEnabled,
      heroStyle,
    };
  },
});
</script>
